export default {"src":"/_next/static/media/profileGreyNew.14784d50.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};